import { createContext, useContext } from 'react';
import { MobileAction, MobileState } from './state';

type MobileContextType = {
    state: MobileState;
    dispatch: React.Dispatch<MobileAction>;
};

export const MobileContext = createContext<MobileContextType | null>(null);

export const useMobileState = () => {
    const context = useContext(MobileContext);
    if (!context) {
        throw new Error('useMobileState must be used within a MobileProvider');
    }
    return context;
};
